// find page js
var link_buttons = document.querySelectorAll('.find-page .slider-buttons .slider-counter__link');
var current_index = 1;
var selected_options = {};

document.querySelectorAll('.find-page .js-option-item').forEach(function (item, index) {
    item.addEventListener('click', function() {
        var next_index = this.getAttribute('data-next');
        triggerEvent(next_index);

        var option_wrapper = this.closest('.js-option-wrapper');
        if (!option_wrapper) return
        var option_title = this.closest('.js-option-wrapper').getAttribute('data-option-title');
        var option_value = this.getAttribute('data-option-value');
        console.log('option_title', option_title);
        console.log('option_value', option_value);
        if (option_title && option_value) {
            selected_options[option_title] = option_value;
        }
        console.log('selected_options', selected_options);
    })
})
document.querySelectorAll('.find-page .js-multi').forEach(function (item){
    item.addEventListener('click', function() {
        this.classList.toggle('active')
    })
})
document.querySelectorAll('.find-page button[name="back"]').forEach(function (item, index) {
    item.addEventListener('click', function() {
        var prev_index = this.getAttribute('data-prev');
        triggerEvent(prev_index ? prev_index : current_index - 1);
    })
})
document.querySelector('.find-page button[name="result"]').addEventListener('click', function() {
    console.log('selected_options', selected_options);
    var query = '';
    for (var key in selected_options) {
        query += key + '=' + selected_options[key] + '&';
    }
    query = query.slice(0, -1);
    console.log('query', query);
    window.location.href = '/pages/finded?' + query;
})

function triggerEvent(index) {
    var click = new Event('click')
    current_index = index;
    link_buttons[index - 1].dispatchEvent(click);
    updateStep(index);
}

var step_wrapper_node = document.querySelector('.quiz__progress-bar');
var step_nodes = document.querySelectorAll('.quiz__progress-bar-nodes [aria-controls="quiz__choice-groups"], .quiz__progress-bar-nodes .cursor-not-allowed');
var separators = document.querySelectorAll('.quiz__progress-bar-separators path');
var indexer_node = document.querySelector('.mobile-indexer');

step_nodes.forEach(function (item, index) {
    item.addEventListener('click', function() {
       console.log(index);
        triggerEvent(index+1)
    })
})
function updateStep(newPage) {
    var visited = '#A26219';
    var idle = "#003b95";
    if (newPage > 1 && newPage < 8 || (newPage == 10 && selected_options.who == 'adult')) {
        indexer_node.classList.add('show');
        step_wrapper_node.classList.add('show');
    } else {
        indexer_node.classList.remove('show');
        step_wrapper_node.classList.remove('show');
    }
    indexer_node.querySelector('.current-index').innerHTML = newPage;
    step_nodes.forEach(function (nodeGroup, ind) {
        if (ind < newPage) {
          nodeGroup.children[0].setAttribute('fill', visited);
          nodeGroup.children[0].setAttribute('stroke', visited); // <text>
          nodeGroup.children[1].setAttribute('fill', visited);
        } else {
          // <rect>
          nodeGroup.children[0].setAttribute('fill', '#F8F7F7');
          nodeGroup.children[0].setAttribute('stroke', idle); // <text>
          nodeGroup.children[1].setAttribute('fill', idle);
        }
    });
    separators.forEach(function (line, ind) {
        line.setAttribute('stroke', ind + 1 < newPage ? visited : idle);
    });
}